import { render, staticRenderFns } from "./_ProxyStoreCategoryItem.vue?vue&type=template&id=6f339666&"
import script from "./_ProxyStoreCategoryItem.vue?vue&type=script&lang=js&"
export * from "./_ProxyStoreCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./_ProxyStoreCategoryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports